/**
 * Generate a unique session ID
 * Uses crypto.randomUUID() for secure random IDs
 */
export function generateSessionId(): string {
  return crypto.randomUUID();
}
